import React from "react";
import {CategoryArrow, CategoryDiv, CategoryTitle, IconWrapper} from "./Category.styles";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faChartBar,
    faFutbol,
    faMedal,
    faNewspaper,
    faTrophy,
    faUsers
} from "@fortawesome/free-solid-svg-icons";
import PropTypes from 'prop-types';

const Category = ({type, onClick}) => {

    const categoryInfo = {
        achievements: {
            icon: faTrophy,
            title: 'Największe osiągniecia zespołu',
            color: '#00640090'
        },
        tournaments: {
            icon: faMedal,
            title: 'Historia rozegranych turniejów',
            color: '#00008B90'
        },
        matches: {
            icon: faFutbol,
            title: 'Historia rozegranych spotkań',
            color: '#99990090'
        },
        statistics: {
            icon: faChartBar,
            title: 'Szczegółowe statystyki zespołu',
            color: '#b8770090'
        },
        admin_posts: {
            icon: faNewspaper,
            title: 'Posty\n/posts',
            color: '#FFA50090'
        },
        admin_players: {
            icon: faUsers,
            title: 'Zawodnicy\n/players',
            color: '#FF000090'
        },
        admin_matches: {
            icon: faFutbol,
            title: 'Mecze\n/matches',
            color: '#0000FF90'
        },
        admin_tournaments: {
            icon: faTrophy,
            title: 'Turnieje\n/tournaments',
            color: '#00FF0090'
        }
    }

    return (<CategoryDiv color={categoryInfo[type].color} href={'#' + type} onClick={onClick}>
        <IconWrapper>
            <FontAwesomeIcon icon={categoryInfo[type].icon} color={'white'} style={{width: 60, height: 60}}/>
        </IconWrapper>
        <CategoryTitle>{categoryInfo[type].title}</CategoryTitle>
        <CategoryArrow/>
    </CategoryDiv>);
};

Category.propTypes = {
    onClick: PropTypes.func,
    type: PropTypes.oneOf(['achievements', 'tournaments', 'matches', 'statistics', 'admin_posts', 'admin_players', 'admin_matches', 'admin_tournaments'])
}

Category.defaultProps = {
    type: 'statistics'
}

export default Category;
